// 钻石销售信息
<template>
    <div class="list-container">
        <!-- 顶部导航栏 -->
        <div class="top-header">
            <div class="header-left" @click="goBack">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="header-center">
                <h3>钻石搜索</h3>
            </div>
            <div class="header-right" @click="goToCart">
                <i class="el-icon-shopping-cart-full"></i>
            </div>
            <div class="header-right" @click="goToMyOrder">
                <i class="el-icon-document"></i>
            </div>
        </div>

        <!-- 结果列表区域 -->
        <div class="result-section">
            <div class="result-content">
                <!-- 操作按钮和统计信息 -->
                <div class="filter-section">
                    <div class="action-bar">
                        <el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">{{ $t('button.getCertNo') }}</el-button>
                        <el-button type="success" @click="dialogTableVisible3 = true" size="small" :disabled="isAble">{{ $t('button.batchOrder') }}</el-button>
                        <!--<el-button v-else type="success" @click="savaAllOrderInfo2" size="small" :disabled="isAble">{{ $t('button.batchOrder') }}</el-button>-->
                        <!--<el-button type="success" @click="dialogTableVisible3 = true" size="small" :disabled="isAble">{{ $t('button.batchOrder') }}</el-button>-->
                        <el-button type="primary" @click="savaAllShopInfo" :disabled="isAble" size="small">{{ $t('button.batchToCart') }}</el-button>
                        <el-button type="primary" @click="selectCertnoCopy" :disabled="isAble" size="small">钻石报价</el-button>
                        <el-button type="primary" @click="dialogTableVisible2 = true" size="small" :disabled="isAble" style="margin-top:10px;">修改地点</el-button>
                        <!--<el-button type="primary" @click="exportAllList" size="small" :style="{display:visibleLine}">{{ $t('button.exportAll') }}</el-button>-->
                        <!--<el-button type="success" @click="uploadRapnetHKFile" size="small" :style="{display:visibleLine}">{{ $t('button.uploadRapnet') }}</el-button>-->
                        <el-button type="success" @click="uploadRapnetFile" size="small" style="margin-top:10px;">SZ上传RAP</el-button>
                    </div>
                    <div class="statistics-info">
                        <span>{{ $t('common.Selected') }}: {{data_len}}； {{ $t('common.TotalW') }}: {{ ct_total }}； {{ $t('common.TotalP') }}: ${{ sale_usd_total }}；</span>
                    </div>
                </div>
                
                <!-- 结果表格 -->
                <div class="filter-section table-section">
                    <!--分页-->
                    <div class="pagination-bar">
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[10, 20, 50, 200]" :page-size="pager.rows"
                                       layout="total,sizes, prev, next"
                                       :total="pager.total"></el-pagination>
                    </div>
                    <div class="table-wrapper">
                        <el-table 
                            :data="diamondInfoList" 
                            stripe
                            @selection-change="selectionLineChangeHandle"
                            @row-click="handleRowClick"
                            ref="refTable" 
                            size="mini"
                            :header-cell-style="{background:'#f0f0f0',color:'#333',fontSize:'11px',padding:'3px 0',fontWeight:'bold'}" 
                            :row-style="{height:'20px',fontSize:'12px',padding:'0',margin:'0'}"
                            :class="['diamond-mobile-table', { 'safari-only': isSafari }]"
                            :height="tableHeight">
                            <el-table-column type="selection" align="left" width="35" :selectable="rowSelectable"></el-table-column>
                            
                            <el-table-column align="center" min-width="97%" :label="$t('common.Details')">
                                <template slot-scope="scope">
                                    <div style="font-size:12px;color:#666;font-weight:bold;display:flex;text-align:left">
                                        <div style="flex:1;text-align:left">
                                            <span>GIA {{ scope.row.cert_no }}</span>
                                        </div>
                                        <div style="flex:1;text-align:left;display:flex;align-items:center;gap:6px;flex-wrap:wrap">
                                            <span>{{ scope.row.place }} {{ scope.row.year }}</span>&nbsp;
                                            <div class="media-links" style="display:flex;align-items:center;gap:8px">
                                                <div v-if="scope.row.image_link" class="image-link">
                                                    <i class="el-icon-picture-outline" 
                                                       @click.stop="viewImage(scope.row.image_link)" 
                                                       title="View Diamond Image"></i>
                                                </div>&nbsp;
                                                <div v-if="scope.row.vedio_link" class="vedio_link">
                                                    <i class="el-icon-video-camera" 
                                                       @click.stop="viewVideo(scope.row.vedio_link)" 
                                                       title="View Diamond Video"></i>
                                                </div>&nbsp;
                                                <div v-if="scope.row.image_link_yuan" class="image_link_yuan">
                                                    <i class="el-icon-picture" 
                                                       @click.stop="viewImage(scope.row.image_link_yuan)" 
                                                       title="View Diamond Image"></i>
                                                </div>&nbsp;
                                                <div v-if="scope.row.vedio_link_yuan" class="vedio_link_yuan">
                                                    <i class="el-icon-video-camera" 
                                                       @click.stop="viewVideo(scope.row.vedio_link_yuan)" 
                                                       title="View Diamond Video"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="font-size:12px;color:#666;font-weight:bold;display:flex;text-align:left">
                                        <div style="flex:1;text-align:left">
                                            <span v-if="scope.row.shape === '圆形'">{{ $t('common.Round') }}</span>
                                            <span v-else-if="scope.row.shape === '公主方'">{{ $t('common.Princess') }}</span>
                                            <span v-else-if="scope.row.shape === '雷迪恩'">{{ $t('common.Radiant') }}</span>
                                            <span v-else-if="scope.row.shape === '阿斯切'">{{ $t('common.Asscher') }}</span>
                                            <span v-else-if="scope.row.shape === '马眼' || scope.row.shape === '马眼形'">{{ $t('common.Marquise') }}</span>
                                            <span v-else-if="scope.row.shape === '椭圆' || scope.row.shape === '椭圆形'">{{ $t('common.Oval') }}</span>
                                            <span v-else-if="scope.row.shape === '祖母绿'">{{ $t('common.Emerald') }}</span>
                                            <span v-else-if="scope.row.shape === '梨形'">{{ $t('common.Pear') }}</span>
                                            <span v-else-if="scope.row.shape === '心形'">{{ $t('common.Heart') }}</span>
                                            <span v-else-if="scope.row.shape === '垫形'">{{ $t('common.Cushion') }}</span>
                                            <span v-else-if="scope.row.shape === '其他'">{{ $t('common.Others') }}</span>
                                            <span v-else-if="scope.row.shape === '三角形'">{{ $t('common.Triangle') }}</span>
                                            <span v-else>{{ scope.row.shape }}</span>
                                            {{ scope.row.ct }}ct 
                                            &nbsp;
                                            {{ scope.row.sale_status }}
                                        </div>
                                        <div style="flex:1;text-align:left">
                                            {{ scope.row.col }} {{ scope.row.cla }}
                                            {{ scope.row.cut }} {{ scope.row.pol }} {{ scope.row.sym }} {{ scope.row.fl }}
                                        </div>
                                    </div>
                                    <div style="font-size:12px;color:#666;font-weight:bold;display:flex;text-align:left">
                                        <div style="flex:1;text-align:left">
                                            <div style="flex:1;text-align:left">{{ scope.row.meas}}mm</div>
                                        </div>
                                        <div style="flex:1;text-align:left">
                                            <span v-if="scope.row.table1">Table:{{ scope.row.table1 }}</span>&nbsp;&nbsp;
                                            <span v-if="scope.row.depth">Depth:{{ scope.row.depth }}</span>
                                        </div>
                                    </div>
                                    <div style="font-size:12px;color:#666;font-weight:bold;display:flex;text-align:left">
                                        <div style="flex:1;text-align:left">
                                            {{ scope.row.sale_rap }}
                                            &nbsp;
                                            <span style="color:#0066ff;font-weight:bold">{{ scope.row.new_dis }}%</span>
                                            &nbsp;&nbsp;
                                            <span style="color:red;font-weight:bold">￥{{ scope.row.sale_price }}</span>
                                        </div>
                                        <div style="flex:1;text-align:left">
                                            <span style="color:#0066ff;font-weight:bold">{{ scope.row.rating }}</span>
                                            &nbsp;
                                            <span style="font-weight:bold">{{ scope.row.remark }}</span>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            
                            <!-- 重量列 
                            <el-table-column align="center" min-width="5%">
                                <template slot-scope="scope">
                                    <div class="media-links">
                                        <div v-if="scope.row.image_link" class="image-link">
                                            <i class="el-icon-picture-outline" 
                                               @click.stop="viewImage(scope.row.image_link)" 
                                               title="View Diamond Image"></i>
                                        </div>
                                        <div v-if="scope.row.vedio_link" class="vedio_link">
                                            <i class="el-icon-video-camera" 
                                               @click.stop="viewVideo(scope.row.vedio_link)" 
                                               title="View Diamond Video"></i>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            -->
                            <!-- 规格列 
                            <el-table-column align="center" min-width="47%" :label="$t('common.Details')">
                                <template slot-scope="scope">
                                    <div style="font-weight:bold">
                                        {{ scope.row.cert_no }}
                                        <span v-if="scope.row.shape === '圆形'">{{ $t('common.Round') }}</span>
                                        <span v-else-if="scope.row.shape === '公主方'">{{ $t('common.Princess') }}</span>
                                        <span v-else-if="scope.row.shape === '雷迪恩'">{{ $t('common.Radiant') }}</span>
                                        <span v-else-if="scope.row.shape === '阿斯切'">{{ $t('common.Asscher') }}</span>
                                        <span v-else-if="scope.row.shape === '马眼' || scope.row.shape === '马眼形'">{{ $t('common.Marquise') }}</span>
                                        <span v-else-if="scope.row.shape === '椭圆' || scope.row.shape === '椭圆形'">{{ $t('common.Oval') }}</span>
                                        <span v-else-if="scope.row.shape === '祖母绿'">{{ $t('common.Emerald') }}</span>
                                        <span v-else-if="scope.row.shape === '梨形'">{{ $t('common.Pear') }}</span>
                                        <span v-else-if="scope.row.shape === '心形'">{{ $t('common.Heart') }}</span>
                                        <span v-else-if="scope.row.shape === '垫形'">{{ $t('common.Cushion') }}</span>
                                        <span v-else-if="scope.row.shape === '其他'">{{ $t('common.Others') }}</span>
                                        <span v-else-if="scope.row.shape === '三角形'">{{ $t('common.Triangle') }}</span>
                                        <span v-else>{{ scope.row.shape }}</span>
                                        
                                    </div>
                                    <div style="font-size:11px;color:#666;font-weight:bold">
                                        {{ scope.row.ct }}ct 
                                        {{ scope.row.col }}  {{ scope.row.cla }}
                                        {{ scope.row.cut }} {{ scope.row.pol }} {{ scope.row.sym }} {{ scope.row.fl }}
                                    </div>
                                    <div style="font-size:11px;color:#666;font-weight:bold">
                                        {{ scope.row.meas}} {{ scope.row.table1 }}  {{ scope.row.depth }} {{ scope.row.year }}
                                    </div>
                                </template>
                            </el-table-column>
                            -->
                            <!-- 折扣列 
                            <el-table-column align="center" min-width="20%" :label="$t('common.Price')">
                                <template slot-scope="scope">
                                    <div style="color:goldenrod;">{{ scope.row.sale_rap }}</div>
                                    <div style="color:#0066ff;font-weight:bold">{{ scope.row.new_dis }}%</div>
                                    <div style="color:fuchsia;font-weight:bold">{{ scope.row.sale_usd }}</div>
                                    
                                    <div style="color:fuchsia;font-weight:bold" v-if="scope.row.place === 'HK' || scope.row.place === 'H-K'">
                                        ${{ scope.row.sale_usd }}
                                    </div>
                                    <div style="color:fuchsia;font-weight:bold" v-else>
                                        ￥{{ scope.row.sale_price }}
                                    </div>
                                    
                                </template>
                            </el-table-column>
                            -->
                            <!-- 来源和价格列
                            <el-table-column align="center" min-width="28%" :label="$t('common.Remark')">
                                <template slot-scope="scope">
                                    <div style="color:#666;font-size:11px;font-weight:bold">{{ scope.row.place}}</div>
                                    <div style="color:#666;font-size:11px;font-weight:bold;white-space:normal;word-wrap:break-word;word-break:break-all;line-height:1.4;">{{ scope.row.rating}}</div>
                                </template>
                            </el-table-column>
                             -->
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 对话框 -->
        <div class="text e-info auto-table">
            <el-dialog :title="$t('common.Order')" :visible.sync = "dialogTableVisible3" @close="closeSava" 
            width="90%" center :close-on-click-modal="false" append-to-body>
                <el-form :inline="true" label-width="100px" size="small" 
                    :model="addDataForm3" class="demo-form-inline" ref="addDataForm3" :rules="rules3">
                    <el-form-item prop="vipCount" :label="$t('common.Customer') + ':'" style="width: 100%;float:left">
                        <el-input v-model="addDataForm3.vipCount" :placeholder="$t('common.pleaseInput')"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaAllOrderInfo">{{ $t('button.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
        <el-dialog
          title="Image"
          :visible.sync="imageDialogVisible"
          width="90%"
          center
          append-to-body
          :close-on-click-modal="true"
          :before-close="handleImageDialogClose">
          <div class="image-dialog-content">
            <img :src="currentImageUrl" alt="Image" class="diamond-image">
          </div>
        </el-dialog>
        
        <el-dialog
          title="Video"
          :visible.sync="videoDialogVisible"
          width="90%"
          center
          append-to-body
          :close-on-click-modal="true"
          :before-close="handleVideoDialogClose">
          <div class="video-dialog-content">
            <video 
              :src="currentVideoUrl" 
              class="diamond-video" 
              controls 
              autoplay
              controlsList="nodownload">
              Your browser does not support the video playback
            </video>
          </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" icon="el-icon-download" @click="downloadVideo">
                    链接
                </el-button>
            </div>
        </el-dialog>
        
        <el-dialog title="钻石报价" :visible.sync="dialogTableVisible7" @close="closeSava" 
            width="90%" center :close-on-click-modal="false" append-to-body>
            <el-form :inline="true" label-width="100px" size="small"
                    :model="baojiaform" class="demo-form-inline" ref="baojiaform">
                <el-form-item prop="all_new_dis" label="折扣加/减：" label-width="90px">
                    <el-input v-model="baojiaform.all_new_dis" placeholder="请输入" @change="dis_change"></el-input>
                </el-form-item>
                <el-form-item prop="all_sale_rate" label="销售汇率：" label-width="90px">
                    <el-input v-model="baojiaform.all_sale_rate" placeholder="请输入" @change="rate_change"></el-input>
                </el-form-item>
                <el-button type="primary" @click="copyPriceInfo" plain size="small">复制报价信息</el-button>
            </el-form>
            <div class="price-summary">
                <div>总价: ¥{{ totalPrice }} / ${{ totalUsdPrice }}</div>
                <div>总重: {{ ct_total }}ct</div>
                <div>数量: {{ data_len }}颗</div>
            </div>
        </el-dialog>

        <div class="text e-info auto-table">
            <el-dialog title="修改地点" :visible.sync = "dialogTableVisible2" @close="closeSava" 
                width="90%" center :close-on-click-modal="false" append-to-body>
                <el-form :inline="true" label-width="100px" size="small" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2" :rules="rules2">
                    <el-form-item prop="place" label="设置地点：">
                        <el-select v-model="addDataForm2.place" placeholder="请选择">
                            <el-option v-for="item in placeList1" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="remark1" label="备注信息：">
                        <el-input v-model="addDataForm2.remark" placeholder="请输入"></el-input>
                    </el-form-item><br>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams1">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    export default {
        data() {
            return {
                tableHeight: 400, // 表格高度，会在mounted时动态计算
                isSafari: false, // 是否为 Safari 浏览器
                isExpand: false,
                isAble: true,
                visibleLine: 'none',
                userType: sessionStorage.getItem('userType') || '',
                isdisabled: false,
                dialogTableVisible: false,
                dialogTableVisible2: false,
                dialogTableVisible3: false,
                dialogTableVisible7: false,
                checkboxGroup1: [],
                checkboxGroup2: [],
                checkboxGroup3: [],
                checkboxGroup4: [],
                checkboxGroup5: [],
                checkboxGroup6: [],
                checkboxGroup7: [],
                checkboxGroup8: [],
                checkboxGroup9: [],
                checkboxGroup10: [],
                checkboxGroup11: [],
                checkboxGroup12: [],
                checkboxGroup13: [],

                shapeList: [{'value':'Round'},{'value':'Princess'},{'value':'Radiant'}
                            ,{'value':'Asscher'},{'value':'Marquise'},{'value':'Oval'}
                            ,{'value':'Emerald'},{'value':'Pear'},{'value':'Heart'}
                            ,{'value':'Cushion'},{'value':'Others'},{'value':'Triangle'}],
                shapeList1: [{'value':'圆形'},{'value':'公主方'},{'value':'雷迪恩'}
                            ,{'value':'阿斯切'},{'value':'马眼'},{'value':'椭圆形'}
                            ,{'value':'祖母绿'},{'value':'梨形'},{'value':'心形'}
                            ,{'value':'垫形'},{'value':'其他'},{'value':'三角形'}],
                colList: [{'value':'D'},{'value':'E'},{'value':'F'}
                            ,{'value':'G'},{'value':'H'},{'value':'I'}
                            ,{'value':'J'},{'value':'K'},{'value':'L'}
                            ,{'value':'M-N'},{'value':'O-Z'}],
                claList: [{'value':'FL'},{'value':'IF'},{'value':'VVS1'}
                            ,{'value':'VVS2'},{'value':'VS1'},{'value':'VS2'}
                            ,{'value':'SI1'},{'value':'SI2'},{'value':'SI3'}
                            ,{'value':'I1'},{'value':'I2'}],
                cutList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'},{'value':'NN'}],
                polList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'}],
                flList: [{'value':'N'},{'value':'VSL'},{'value':'F'}
                            ,{'value':'M'},{'value':'S'},{'value':'VS'}],
                placeList1: [{'value':'HK'},{'value':'CHINA'},{'value':'SZ'}
                            ,{'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                certList: [{'value':'GIA'},{'value':'NGTC'},{'value':'IGI'}
                            ,{'value':'HRD'},{'value':'None'},{'value':'Other'}],
                inv_statusList: [{'value':'在库'},{'value':'不在库'}],
                sale_statusList: [{'value':'在售'},{'value':'保留'},{'value':'借货'}
                            ,{'value':'全款借货'},{'value':'确认销售'},{'value':'已完成'}],
                placeList: ['HK','CN','SZ','INDIA','SH','H-K'],
                colorlist: ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-N', 'O-Z'],
                clalist: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3','I1','I2'],
                cutlist: ['EX', 'VG', 'GD', 'FR', 'PR', 'NN'],
                pollist: ['EX', 'VG', 'GD', 'FR', 'PR'],
                fllist: ['N', 'VSL', 'F', 'M', 'S', 'VS'],
                certlist: ['GIA', 'NGTC', 'IGI', 'HRD', 'None', 'Other'],
                inv_status: '',
                addDataForm: {},
                addDataForm2: {},
                addDataForm3: {
                    'sale_status': '1',
                    'tiaodian1': '1',
                    'date_long': '24h',
                    'vipCount': sessionStorage.getItem('userName')
                },
                addDataForm4: {},
                addDataForm5: {},
                addDataForm6: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                sale_priceList: [],
                idList: [],
                idStr: '',
                cert_noStr: '',
                sale_priceStr: '',
                diamondInfoList: [],
                diamondAllInfoList: {},
                diamondCZInfoList: {},
                diamondRapnetInfoList: {},
                imgViewerVisible:false,
                ratevalue: '',
                ct_total: 0,
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                exportHKFile: '',
                // 查询
                query: {
                    sale_status: '在售',
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    addPoint: 0,
                    milkCoffeeGreen: '',
                    noBlack: false,
                    cleanEye: false,
                    hasImage: false,
                    inStock: false,
                    isClosed: false,
                    hasSpecialPrice: false,
                    supplier: '',
                    stockNumber: ''
                },
                column: 'sale_price',
                order: 'asc',
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 20,
                    total: 0
                },
                rules2:{
                    place:[
                        {
                            required:true,
                            message:'请选择',
                            trigger:'blur'
                        }
                    ],
                    upload_date:[
                        {
                            required:true,
                            message:'请选择日期',
                            trigger:'blur'
                        }
                    ]
                },
                rules3:{
                    vipCount:[
                        {
                            required:true,
                            message:'Please input customer!',
                            trigger:'blur'
                        }
                    ]
                },
                imageDialogVisible: false,
                currentImageUrl: '',
                videoDialogVisible: false,
                currentVideoUrl: '',
                baojiaform: {
                    all_new_dis: '',
                    all_sale_rate: ''
                },
                totalPrice: 0,
                totalUsdPrice: 0
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectDiamondInfoList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectDiamondInfoList();
            },
            // shape 形状
            toggleShape(value) {
                if (this.checkboxGroup1.includes(value)) {
                    this.checkboxGroup1 = this.checkboxGroup1.filter((v) => v !== value);
                } else {
                    this.checkboxGroup1.push(value);
                }
                this.query.shape = this.checkboxGroup1.join();
            },
            // 获取形状图标名称
            getShapeIcon(shape) {
                const shapeMap = {
                    'Round': 'round',
                    'Princess': 'princess',
                    'Radiant': 'radiant',
                    'Asscher': 'asscher',
                    'Marquise': 'marquise',
                    'Oval': 'oval',
                    'Emerald': 'emerald',
                    'Pear': 'pear1',
                    'Heart': 'heart',
                    'Cushion': 'cushion',
                    'Others': 'others',
                    'Triangle': 'triangle'
                };
                return shapeMap[shape] || 'round';
            },
            // 返回
            goBack() {
                this.$router.push('/phone/diamondShopSelect');
            },
            // 跳转到购物车
            goToCart() {
                this.$router.push('/phone/shoppingMobile');
            },
            // 跳转到我的订单
            goToMyOrder() {
                this.$router.push('/phone/myDiamondListMobile');
            },
            // 颜色
            toggleColor(value) {
                if (this.checkboxGroup2.includes(value)) {
                    this.checkboxGroup2 = this.checkboxGroup2.filter((v) => v !== value);
                } else {
                    this.checkboxGroup2.push(value);
                }
                this.query.col = this.checkboxGroup2.join();
            },
            // 地点
            togglePlace(value) {
                if (this.checkboxGroup12.includes(value)) {
                    this.checkboxGroup12 = this.checkboxGroup12.filter((v) => v !== value);
                } else {
                    this.checkboxGroup12.push(value);
                }
                this.query.place = this.checkboxGroup12.join();
            },
            // 净度
            toggleClarity(value) {
                if (this.checkboxGroup3.includes(value)) {
                    this.checkboxGroup3 = this.checkboxGroup3.filter((v) => v !== value);
                } else {
                    this.checkboxGroup3.push(value);
                }
                this.query.cla = this.checkboxGroup3.join();
            },
            // 切工
            toggleCut(value) {
                if (this.checkboxGroup4.includes(value)) {
                    this.checkboxGroup4 = this.checkboxGroup4.filter((v) => v !== value);
                } else {
                    this.checkboxGroup4.push(value);
                }
                this.query.cut = this.checkboxGroup4.join();
            },
            // 抛光
            togglePolish(value) {
                if (this.checkboxGroup5.includes(value)) {
                    this.checkboxGroup5 = this.checkboxGroup5.filter((v) => v !== value);
                } else {
                    this.checkboxGroup5.push(value);
                }
                this.query.pol = this.checkboxGroup5.join();
            },
            // 对称
            toggleSymmetry(value) {
                if (this.checkboxGroup6.includes(value)) {
                    this.checkboxGroup6 = this.checkboxGroup6.filter((v) => v !== value);
                } else {
                    this.checkboxGroup6.push(value);
                }
                this.query.sym = this.checkboxGroup6.join();
            },
            // 荧光
            toggleFluorescence(value) {
                if (this.checkboxGroup7.includes(value)) {
                    this.checkboxGroup7 = this.checkboxGroup7.filter((v) => v !== value);
                } else {
                    this.checkboxGroup7.push(value);
                }
                this.query.fl = this.checkboxGroup7.join();
            },
            // 证书
            toggleCert(value) {
                if (this.checkboxGroup8.includes(value)) {
                    this.checkboxGroup8 = this.checkboxGroup8.filter((v) => v !== value);
                } else {
                    this.checkboxGroup8.push(value);
                }
                this.query.cert = this.checkboxGroup8.join();
            },
            // 联动赋值重量
            ctChange(val) {
                if(val == 3) {
                    this.$set(this.query,'ct1','0.30');
                    this.$set(this.query,'ct2','0.39');
                }else if(val == 4) {
                    this.$set(this.query,'ct1','0.40');
                    this.$set(this.query,'ct2','0.49');
                }else if(val == 5) {
                    this.$set(this.query,'ct1','0.50');
                    this.$set(this.query,'ct2','0.59');
                }else if(val == 6) {
                    this.$set(this.query,'ct1','0.60');
                    this.$set(this.query,'ct2','0.69');
                }else if(val == 7) {
                    this.$set(this.query,'ct1','0.70');
                    this.$set(this.query,'ct2','0.79');
                }else if(val == 8) {
                    this.$set(this.query,'ct1','0.80');
                    this.$set(this.query,'ct2','0.89');
                }else if(val == 9) {
                    this.$set(this.query,'ct1','0.90');
                    this.$set(this.query,'ct2','0.99');
                }else if(val == 10) {
                    this.$set(this.query,'ct1','1.00');
                    this.$set(this.query,'ct2','1.09');
                }else if(val == 11) {
                    this.$set(this.query,'ct1','1.10');
                    this.$set(this.query,'ct2','1.49');
                }else if(val == 12) {
                    this.$set(this.query,'ct1','1.50');
                    this.$set(this.query,'ct2','1.99');
                }else if(val == 13) {
                    this.$set(this.query,'ct1','2.00');
                    this.$set(this.query,'ct2','2.99');
                }else if(val == 14) {
                    this.$set(this.query,'ct1','3.00');
                    this.$set(this.query,'ct2','3.99');
                }else if(val == 15) {
                    this.$set(this.query,'ct1','4.00');
                    this.$set(this.query,'ct2','4.99');
                }else if(val == 16) {
                    this.$set(this.query,'ct1','5.00');
                    this.$set(this.query,'ct2','9.99');
                }
            },
            // 手动输入重量
            ctSelect(e) {
                let value = e.target.value;
                if(value) {
                    console.log(value)
                    if(value.includes('-')){
                        this.$nextTick(()=> {
                            this.$set(this.query,'ct',value);
                        })
                        // this.query.ct = value;
                        let valArr = value.split('-');
                        this.$set(this.query,'ct1',valArr[0]);
                        this.$set(this.query,'ct2',valArr[1]);
                        console.log(this.query.ct1);
                        console.log(this.query.ct2);
                    }
                }
            },
            // 手动输入重量2
            ctChange3(value) {
                if(value) {
                    this.$set(this.query,'ct','');
                    console.log(value)
                    this.$set(this.query,'ct1',value);
                    console.log(this.query.ct1);
                }
            },
            ctChange4(value) {
                if(value) {
                    console.log(value)
                    this.$set(this.query,'ct2',value);
                    console.log(this.query.ct2);
                }
            },
            // 3EXN
            select3exn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX'];
                this.checkboxGroup6 = ['EX'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX';
                this.query.sym = 'EX';
                this.query.fl = 'N';
            },
            // 3VGN
            select3vgn() {
                this.checkboxGroup4 = ['EX','VG'];
                this.checkboxGroup5 = ['EX','VG'];
                this.checkboxGroup6 = ['EX','VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // 3GDN
            select3gdn() {
                this.checkboxGroup4 = ['EX','VG','GD'];
                this.checkboxGroup5 = ['EX','VG','GD'];
                this.checkboxGroup6 = ['EX','VG','GD'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG,GD';
                this.query.pol = 'EX,VG,GD';
                this.query.sym = 'EX,VG,GD';
                this.query.fl = 'N';
            },
            // 3FRN
            select3frn() {
                this.checkboxGroup4 = ['EX','VG','GD','FR'];
                this.checkboxGroup5 = ['EX','VG','GD','FR'];
                this.checkboxGroup6 = ['EX','VG','GD','FR'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG,GD,FR';
                this.query.pol = 'EX,VG,GD,FR';
                this.query.sym = 'EX,VG,GD,FR';
                this.query.fl = 'N';
            },
            // 选择器选择数据，加工数据证书号、统计数据
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 计算总销售额
                let sale_rap1 = 0;
                let sale_usd1 = 0;
                let sale_price1 = 0;
                let ct1 = 0;
                for(let a = 0; a < this.data_len; a++) {
                    console.log(val[a].sale_price);
                    console.log(val[a].ct);
                    // 进货价
                    sale_rap1 += val[a].sale_rap;
                    // 销售价格
                    sale_usd1 += val[a].sale_usd;
                    sale_price1 += val[a].sale_price;
                    // 重量
                    ct1 += parseFloat(val[a].ct);
                }
                // 进货价
                this.sale_rap_total = sale_rap1.toFixed(2);
                // 销售价格
                this.sale_usd_total = sale_usd1.toFixed(2);
                this.sale_price_total = sale_price1.toFixed(2);
                // 总重量
                this.ct_total = ct1.toFixed(2);
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                this.sale_priceList = val.map((item) => item.sale_price);
                //数据选中后，显示按钮
                if(this.certnoList.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                console.log(this.certnoStr)
                // 复制
                this.copyText(this.certnoStr);
            },
            // 带证书号复制
            selectCertnoCopy() {
                this.dialogTableVisible7 = true;
                
                // 初始化汇率
                if (!this.baojiaform.all_sale_rate && this.ratevalue) {
                    this.baojiaform.all_sale_rate = this.ratevalue;
                }
                
                // 计算总价
                this.calculateTotalPrice();
            },
            
            // 折扣变化
            dis_change() {
                this.calculateTotalPrice();
            },
            
            // 汇率变化
            rate_change() {
                this.calculateTotalPrice();
            },
            
            // 计算总价
            calculateTotalPrice() {
                if (!this.dataOnLineListSelections || this.dataOnLineListSelections.length === 0) {
                    this.totalPrice = 0;
                    this.totalUsdPrice = 0;
                    return;
                }
                
                let totalRmb = 0;
                let totalUsd = 0;
                
                // 遍历选中的钻石
                for (let item of this.dataOnLineListSelections) {
                    // 计算调整后的价格
                    let newDis = parseFloat(item.new_dis);
                    let saleRate = parseFloat(this.ratevalue);
                    
                    // 如果有输入折扣调整，应用它
                    if (this.baojiaform.all_new_dis) {
                        newDis = newDis + parseFloat(this.baojiaform.all_new_dis);
                    }
                    
                    // 如果有输入汇率，应用它
                    if (this.baojiaform.all_sale_rate) {
                        saleRate = parseFloat(this.baojiaform.all_sale_rate);
                    }
                    
                    // 计算美元价格 = (Rap价格 * (1 + 折扣/100) * 克拉)
                    let usdPrice = (item.sale_rap * (1 + (newDis / 100)) * parseFloat(item.ct)).toFixed(2);
                    
                    // 计算人民币价格 = 美元价格 * 汇率
                    let rmbPrice = Math.round(saleRate * usdPrice);
                    
                    totalRmb += rmbPrice;
                    totalUsd += parseFloat(usdPrice);
                }
                
                this.totalPrice = Math.round(totalRmb);
                this.totalUsdPrice = Math.round(totalUsd);
            },
            
            // 复制报价信息
            copyPriceInfo() {
                if (!this.dataOnLineListSelections || this.dataOnLineListSelections.length === 0) {
                    this.$message({
                        message: "No diamond selected",
                        type: "warning",
                    });
                    return;
                }
                
                var dataCopyStr = '';
                var forlist = this.dataOnLineListSelections;
                
                for (var i = 0; i < forlist.length; i++) {
                    let placeStr = '深圳';
                    if (forlist[i].place === 'HK' || forlist[i].place === 'hk' || forlist[i].place === 'H-K') {
                        placeStr = '香港';
                    } else if (forlist[i].place === 'CHINA' || forlist[i].place === 'china' || forlist[i].place === 'CN') {
                        placeStr = '中国';
                    } else if (forlist[i].place === 'sh' || forlist[i].place === 'SH') {
                        placeStr = '上海';
                    }
                    
                    // 计算调整后的价格
                    let newDis = parseFloat(forlist[i].new_dis);
                    let saleRate = parseFloat(this.ratevalue);
                    
                    // 如果有输入折扣调整，应用它
                    if (this.baojiaform.all_new_dis) {
                        newDis = newDis + parseFloat(this.baojiaform.all_new_dis);
                    }
                    
                    // 如果有输入汇率，应用它
                    if (this.baojiaform.all_sale_rate) {
                        saleRate = parseFloat(this.baojiaform.all_sale_rate);
                    }
                    
                    // 计算美元价格 = (Rap价格 * (1 + 折扣/100) * 克拉)
                    let usdPrice = (forlist[i].sale_rap * (1 + (newDis / 100)) * parseFloat(forlist[i].ct)).toFixed(2);
                    
                    // 计算人民币价格 = 美元价格 * 汇率
                    let rmbPrice = Math.round(saleRate * usdPrice);
                    
                    var dataCopy = forlist[i].shape + ', ' + forlist[i].ct + ', ' + forlist[i].col + ', ' + forlist[i].cla
                            + ', ' + forlist[i].cut + ', ' + forlist[i].pol + ', ' + forlist[i].sym + ', ' + forlist[i].fl
                            + ', ' + newDis.toFixed(1) + '%, ¥' + rmbPrice
                            + ', ' + forlist[i].cert + ', ' + forlist[i].cert_no + ', ' + placeStr + '；';
                    
                    if (dataCopyStr == '') {
                        dataCopyStr = dataCopy;
                    } else {
                        dataCopyStr = dataCopyStr + '\n' + dataCopy;
                    }
                }
                
                // 添加总计信息
                dataCopyStr += '\n总计: ' + this.data_len + '颗, ' + this.ct_total + 'ct, ¥' + this.totalPrice;
                
                // 复制
                this.copyText(dataCopyStr);
                
                this.$message({
                    message: "Success!",
                    type: "success",
                });
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "Success!",
                    type: "success",
                });
            },
            // 前端处理 选中数据导出
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['CertNo','Place', 'Status', 'Shape', 'Weight', 'Color'
                            , 'Clarity', 'Cut', 'Polish', 'Symmetry', 'Fluorescence', 'Certificate'
                            , 'SaleRap', 'Discount', 'SaleUSD'
                            , 'Size', 'Table', 'Depth', 'Ratio','Rating','Year'
                            ,'image_link','vedio_link','image_link_2','vedio_link_2']
                    const filterVal = ['cert_no', 'place', 'sale_status', 'shape', 'ct', 'col'
                            ,'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'new_dis', 'sale_usd'
                            ,'meas', 'table1', 'depth', 'ratio','rating','year'
                            ,'image_link','vedio_link','image_link_2','vedio_link_2']
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, 'DiamondInfo')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['CertNo','Place', 'Status', 'Shape', 'Weight', 'Color'
                            , 'Clarity', 'Cut', 'Polish', 'Symmetry', 'Fluorescence', 'Certificate'
                            , 'SaleRap', 'Discount', 'SaleUSD'
                            , 'Size', 'Table', 'Depth', 'Ratio','Rating','Year'
                            ,'image_link','vedio_link','image_link_2','vedio_link_2']
                    const filterVal = ['cert_no', 'place', 'sale_status', 'shape', 'ct', 'col'
                            ,'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'new_dis', 'sale_usd'
                            ,'meas', 'table1', 'depth', 'ratio','rating','year'
                            ,'image_link','vedio_link','image_link_2','vedio_link_2']
                    const list = this.diamondAllInfoList
                    list.forEach(item =>{
                        if(item.sale_status === '在售'){
                            this.$set(item,'sale_status','G')
                        }else if(item.sale_status === '锁单'){
                            this.$set(item,'sale_status','L')
                        }else if(item.sale_status === '保留'){
                            this.$set(item,'sale_status','H')
                        }else if(item.sale_status === '外借'){
                            this.$set(item,'sale_status','M')
                        }else{
                            this.$set(item,'sale_status',item.sale_status)
                        }
                        if(item.shape === '圆形'){
                            this.$set(item,'shape','Round')
                        }else if(item.shape === '公主方') {
                            this.$set(item,'shape','Princess')
                        }else if(item.shape === '雷迪恩') {
                            this.$set(item,'shape','Radiant')
                        }else if(item.shape === '阿斯切') {
                            this.$set(item,'shape','Asscher')
                        }else if(item.shape === '马眼形' || item.shape === '马眼') {
                            this.$set(item,'shape','Marquise')
                        }else if(item.shape === '椭圆' || item.shape === '椭圆形') {
                            this.$set(item,'shape','Oval')
                        }else if(item.shape === '祖母绿') {
                            this.$set(item,'shape','Emerald')
                        }else if(item.shape === '梨形') {
                            this.$set(item,'shape','Pear')
                        }else if(item.shape === '心形') {
                            this.$set(item,'shape','Heart')
                        }else if(item.shape === '垫形') {
                            this.$set(item,'shape','Cushion')
                        }else if(item.shape === '其他') {
                            this.$set(item,'shape','Others')
                        }else if(item.shape === '三角形') {
                            this.$set(item,'shape','Triangle')
                        }
                    })
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, 'DiamondInfo')
                })
            },
            /*
            // 批量加入购物车
            exportHKFile() {
                let _this = this;
                util.publicget('/shoppingHK/exportHKFile', {
                    user: sessionStorage.getItem('userName'),
                    // user: document.cookie.split(';')[1].split('=')[1],
                }, function (res) {
                    if (res.flag) {
                        //_this.exportHKFile = 'https://mn.ldsgia.com/static/data/' + res.file_path;
                        _this.exportHKFile = 'http://192.168.110.145:8200/ldspj/' + res.file_path;
                        // 在微信环境下显示提示框
                        _this.$alert(_this.exportHKFile , _this.$t('common.Tips'), {
                            confirmButtonText: _this.$t('button.confirm'),
                            type: 'warning',
                            center: true
                        });
                        _this.successMsg("Success!");
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            // 检测是否为微信浏览器
            isWeChat() {
                const ua = navigator.userAgent || '';
                return /micromessenger/i.test(ua);
            },
            /*
            // 查询全部数据用于导出
            exportAllList() {
                let _this = this;
                // 检测是否为微信浏览器
                if (_this.isWeChat()) {
                    util.publicget('/shoppingHK/exportHKFile', {
                        user: sessionStorage.getItem('userName'),
                        // user: document.cookie.split(';')[1].split('=')[1],
                    }, function (res) {
                        if (res.flag) {
                            _this.exportHKFile = 'https://mn.ldsgia.com/ldspj/shoppingHK/downloadHKFile?fileName=DiamondData.xlsx';
                            //_this.exportHKFile = 'http://192.168.110.145:8200/ldspj/DiamondData.xlsx';
                            // 在微信环境下显示提示框
                            _this.$alert(_this.$t('msg.wechatDownloadTip') + '\n' + _this.exportHKFile , _this.$t('common.Tips'), {
                                confirmButtonText: _this.$t('button.copy'),
                                type: 'warning',
                                center: true
                            }).then(() => {
                                // 复制内容到剪贴板
                                _this.copyText(_this.exportHKFile);
                            });
                            //_this.successMsg("Success!");
                        }
                    });
                    return;
                }
                // 非微信环境，正常执行下载
                util.publicget('/shoppingHK/getDaimondAllList2ByCondition', {
                    username: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondAllInfoList = res.obj;
                            for(let a = 0; a < _this.diamondAllInfoList.length; a++) {
                                _this.$set(_this.diamondAllInfoList[a],'new_dis',(_this.diamondAllInfoList[a].new_dis.toFixed(2)))
                                _this.$set(_this.diamondAllInfoList[a],'sale_usd',Number(Math.round(_this.diamondAllInfoList[a].sale_usd)))
                                _this.$set(_this.diamondAllInfoList[a],'ct',Number(_this.diamondAllInfoList[a].ct))
                            }
                            _this.exportAll();
                        }else {
                            _this.errorMsg("Failed!");
                        }
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            // 加载分页数据信息
            selectDiamondInfoList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondListPageModel', {
                    //user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    //token: sessionStorage.getItem('token_time'),
                    sale_status: _this.query.sale_status==''?'在售':_this.query.sale_status,
                    shape: _this.query.shape,
                    col: _this.query.col,
                    cla: _this.query.cla,
                    cut: _this.query.cut,
                    pol: _this.query.pol,
                    sym: _this.query.sym,
                    fl: _this.query.fl,
                    place: _this.query.place,
                    cert: _this.query.cert,
                    cert_no: _this.query.cert_no,
                    greaterEqualsCt: _this.query.ct1,
                    lessEqualsCt: _this.query.ct2,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows,
                    order: _this.order,
                    column: _this.column,
                    order: _this.order,
                    column: _this.column
                }, function (res) {
                    if (res.flag) {
                        console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.diamondInfoList = res.obj;
                        _this.certnoList = res.obj.map((item) => item.cert_no + '\n');
                        _this.idList = res.obj.map((item) => item.id);
                        for(let a = 0; a < _this.diamondInfoList.length; a++) {
                            _this.$set(_this.diamondAllInfoList[a],'table1',(_this.diamondAllInfoList[a].table1.toFixed(2)))
                            _this.$set(_this.diamondAllInfoList[a],'depth',(_this.diamondAllInfoList[a].depth.toFixed(2)))
                        }
                        // _this.successMsg('查询成功!');
                    } else {
                        _this.errorMsg('Failed!');
                        //_this.$router.push({path: '/login'});
                        //_this.$router.push('/login'); // 跳转 login 登陆页面
                    }
                });
            },
            // 批量加入购物车
            savaAllShopInfo() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/shopping/savaShopInfo', {
                    user: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                    // user: document.cookie.split(';')[1].split('=')[1],
                    id: idStr,
                    cert_no: cert_noStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 客户批量下单
            savaAllOrderInfo() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                _this.dialogTableVisible3 = false;
                this.$refs.addDataForm3.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/shopping/savaOrderInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: (sessionStorage.getItem('userName') == null ? document.cookie.split(';')[1].split('=')[1] : sessionStorage.getItem('userName') ),
                            token: sessionStorage.getItem('token_time'),
                            id: idStr,
                            cert_no: cert_noStr,
                            vip: _this.addDataForm3.vipCount
                        }, function (res) {
                            if (res.flag) {
                                console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible3 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.successMsg(res.msg);
                            }
                        })
                    }
                });
            },
            /*
            // 客户批量下单
            savaAllOrderInfo2() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/shopping/savaOrderInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                    id: idStr,
                    cert_no: cert_noStr,
                    vip: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        console.log(res);
                        _this.successMsg("Success!");
                        _this.dialogTableVisible3 = false;
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            */
           // 修改数据状态
           savaDataParams1() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // 地点需要校验
                if(_this.dialogTableVisible2){
                    console.log(_this.dialogTableVisible2);
                    _this.rules2.place[0].required = true;
                    _this.rules2.upload_date[0].required = false;
                }
                // 到货日需要校验
                if(_this.dialogTableVisible5){
                    _this.rules2.place[0].required = false;
                    _this.rules2.upload_date[0].required = true;
                }
                console.log("开始校验字段");
                this.$refs.addDataForm2.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/savaDaimondInfoStatus', {
                            user: document.cookie.split(';')[1].split('=')[1],
                            sale_status: _this.addDataForm2.sale_status,
                            place: _this.addDataForm2.place,
                            upload_date: _this.addDataForm2.upload_date,
                            remark: _this.addDataForm2.remark,
                            id: _this.idStr,
                            cert_no: _this.cert_no
                        }, function (res) {
                            if (res.flag) {
                                console.log("返回结果！");
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible1 = false;
                                _this.dialogTableVisible2 = false;
                                _this.addDataForm2 = {};
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // SZ上传rapnet
            uploadRapnetFile() {
                let _this = this;
                util.publicget('/diamond/uploadRapnetFile', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        //window.location.href = "/download/data/"+res.file_path;
                        _this.successMsg('Success!');
                    } else {
                        _this.errorMsg('Failed!');
                    }
                });
            },
            /*
            // HK上传rapnet
            uploadRapnetHKFile() {
                let _this = this;
                _this.showMsg('upload Rapnet, please do not repeat the operation!');
                util.publicget('/diamondHK/uploadRapnetFileMultipart3', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        //window.location.href = "/download/data/"+res.file_path;
                        _this.successMsg('Success!');
                    } else {
                        _this.errorMsg('Failed!');
                    }
                });
            },
            */
            /*
            // 加入购物车
            savaShopInfo(rows) {
                let _this = this;
                _this.idStr = rows.id;
                _this.cert_noStr = rows.cert_no;
                _this.sale_priceStr = rows.sale_price;
                util.publicget('/shopping/savaShopInfo', {
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr,
                    cert_no: _this.cert_noStr,
                    sale_price: _this.sale_priceStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg("Success!");
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            // dialog 关闭，数据清空
            closeSava() {
                this.selectDiamondInfoList();
                this.dialogTableVisible2 = false;
                this.addDataForm2 = {};
                this.$set(_this.addDataForm3,'sale_status',1);
                this.$set(_this.addDataForm3,'tiaodian1',1);
                this.$set(_this.addDataForm3,'date_long','24h');
                this.$set(_this.addDataForm3,'vipCount',sessionStorage.getItem('userName'));
            },
            /*
            // 查询数据字典 地点
            selectPlaceDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '地点'
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        _this.placeList = res.obj;
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            // 查询数据字典 汇率
            selectRateDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '汇率'
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        _this.ratevalue = res.obj[0].value;
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            
            // 取消
            resetForm(formName) {
                // 重置所有选择组
                this.checkboxGroup1 = [];
                this.checkboxGroup2 = [];
                this.checkboxGroup3 = [];
                this.checkboxGroup4 = [];
                this.checkboxGroup5 = [];
                this.checkboxGroup6 = [];
                this.checkboxGroup7 = [];
                this.checkboxGroup8 = [];
                this.checkboxGroup9 = [];
                this.checkboxGroup11 = [];
                this.checkboxGroup12 = [];
                this.checkboxGroup13 = [];

                // 重置查询对象
                this.query = {
                    data_dt: [],
                    ct: '',
                    ct1: '',
                    ct2: '',
                    ct3: '',
                    ct4: '',
                    shape: '',
                    col: '',
                    cla: '',
                    cut: '',
                    pol: '',
                    sym: '',
                    fl: '',
                    cert: '',
                    place: '',
                    cert_no: '',
                    addPoint: 0,
                    milkCoffeeGreen: '',
                    noBlack: false,
                    cleanEye: false,
                    hasImage: false,
                    inStock: false,
                    isClosed: false,
                    hasSpecialPrice: false,
                    supplier: '',
                    stockNumber: ''
                };
                
                // 如果表单引用存在，也调用el-form的resetFields方法
                if (this.$refs[formName]) {
                    this.$refs[formName].resetFields();
                }
                
                // 强制更新视图
                this.$forceUpdate();
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            // 根据rmb排序
            sortTableFun (column) {
                this.column = column.prop;
                if (column.prop) {
                    if (column.order == 'ascending') {
                        this.order = 'asc'
                    }else if (column.order == 'descending') {
                        this.order = 'desc'
                    }
                    this.selectDiamondInfoList();
                }
            },
            renderHeader (h, {column, $index }) {
                if (column.order == 'ascending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-up'
                            })
                        ]
                    )
                }else if (column.order == 'descending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-down'
                            })
                        ]
                    )
                } else {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort'
                            })
                        ]
                    )
                }
            },
            setPlace(value) {
                this.query.place = value;
            },
            setMilkCoffeeGreen(value) {
                this.query.milkCoffeeGreen = value;
            },
            increasePoint() {
                this.query.addPoint++;
            },
            decreasePoint() {
                if (this.query.addPoint > 0) {
                    this.query.addPoint--;
                }
            },
            rowSelectable(row) {
                // 让所有行都可以被选中，但仅通过点击勾选框
                return true;
            },
            handleRowClick(row, column, event) {
                // 如果点击的是复选框，不做处理
                if (column.type === 'expand' || column.type === 'selection') {
                    return;
                }
                // 切换当前行的选中状态
                this.$refs.refTable.toggleRowSelection(row);
                
                // 可选：添加行选中状态切换
                // this.$refs.refTable.setCurrentRow(row);
            },
            /*
            handleCellClick(row, column, cell, event) {
                // 如果点击的是选择框列，不做额外处理
                if (column.type === 'selection') {
                    return;
                }
                
                // 切换当前行的展开状态
                this.$refs.refTable.toggleRowExpansion(row);
            },*/
            viewImage(imageUrl) {
                if (!imageUrl) return;
                
                // 设置当前图片URL
                if (imageUrl.startsWith('http')) {
                    this.currentImageUrl = imageUrl;
                } else {
                    // 如果不是完整URL，可能需要添加域名前缀
                    this.currentImageUrl = 'https://您的域名/' + imageUrl;
                }
                
                // 显示对话框
                this.imageDialogVisible = true;
            },
            handleImageDialogClose() {
                this.imageDialogVisible = false;
                this.currentImageUrl = '';
            },
            viewVideo(videoUrl) {
                if (!videoUrl) return;
                
                // 设置当前视频URL
                if (videoUrl.startsWith('http')) {
                    this.currentVideoUrl = videoUrl;
                } else {
                    // 如果不是完整URL，可能需要添加域名前缀
                    this.currentVideoUrl = 'https://您的域名/' + videoUrl;
                }
                
                // 显示对话框
                this.videoDialogVisible = true;
            },
            handleVideoDialogClose() {
                this.videoDialogVisible = false;
                this.currentVideoUrl = '';
                
                // 停止视频播放
                const videoElement = document.querySelector('.diamond-video');
                if (videoElement) {
                    videoElement.pause();
                    videoElement.currentTime = 0;
                }
            },

            downloadVideo() {
                const url = this.currentVideoUrl;
                this.copyText(url);
            },

            downloadVideo1() {
                const url = this.currentVideoUrl;
                if (!url) {
                    this.$message.warning('暂无可下载的视频');
                    return;
                }

                // 微信内置浏览器无法直接下载文件
                if (this.isWeChat()) {
                    this.$alert(
                    '请在系统浏览器中打开以下链接下载视频：\n' + url,
                    '提示',
                    {
                        confirmButtonText: '复制链接',
                        type: 'warning',
                        center: true
                    }
                    ).then(() => {
                    this.copyText(url);
                    });
                    return;
                }

                const fileName = decodeURIComponent(
                    url.split('/').pop().split('?')[0] || 'diamond-video.mp4'
                );
                
                fetch(url)
                    .then(res => {
                    if (!res.ok) throw new Error('fetch failed');
                    return res.blob();
                    })
                    .then(blob => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = fileName;  // 指定下载文件名
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(blobUrl);
                    this.$message.success('下载已开始');
                    })
                    .catch(() => {
                    this.$message.error('视频下载失败，可能是跨域限制，请联系管理员配置');
                    });
                },
            // 计算表格高度
            calculateTableHeight() {
                this.$nextTick(() => {
                    const windowHeight = window.innerHeight;
                    const headerHeight = 50; // 顶部导航栏高度
                    const resultContentPadding = 24; // result-content 的上下padding
                    const actionBarHeight = 120; // 操作按钮区域高度（估算）
                    const statisticsHeight = 40; // 统计信息高度（估算）
                    const paginationHeight = 50; // 分页高度（估算）
                    const tableSectionPadding = 24; // table-section 的上下padding
                    
                    // 计算剩余高度
                    const remainingHeight = windowHeight - headerHeight - resultContentPadding 
                                          - actionBarHeight - statisticsHeight - paginationHeight 
                                          - tableSectionPadding;
                    
                    // 设置表格高度，最小200px
                    this.tableHeight = Math.max(remainingHeight, 200);
                });
            }
        },
        mounted() {
            //document.body.style.zoom = 0.74;
            
            // 从路由参数或 sessionStorage 中读取查询参数
            const routeQuery = this.$route.query;
            const savedParams = sessionStorage.getItem('diamondQueryParams');
            
            if (Object.keys(routeQuery).length > 0) {
                // 从路由参数中读取查询条件
                if (routeQuery.shape) this.query.shape = routeQuery.shape;
                if (routeQuery.col) {
                    this.query.col = routeQuery.col;
                    this.checkboxGroup2 = routeQuery.col.split(',').filter(v => v);
                }
                if (routeQuery.cla) {
                    this.query.cla = routeQuery.cla;
                    this.checkboxGroup3 = routeQuery.cla.split(',').filter(v => v);
                }
                if (routeQuery.cut) this.query.cut = routeQuery.cut;
                if (routeQuery.pol) this.query.pol = routeQuery.pol;
                if (routeQuery.sym) this.query.sym = routeQuery.sym;
                if (routeQuery.fl) this.query.fl = routeQuery.fl;
                if (routeQuery.place) {
                    this.query.place = routeQuery.place;
                    this.checkboxGroup12 = routeQuery.place.split(',').filter(v => v);
                }
                if (routeQuery.sale_status) {
                    this.query.sale_status = routeQuery.sale_status;
                    this.checkboxGroup13 = routeQuery.sale_status.split(',').filter(v => v);
                }
                if (routeQuery.cert) this.query.cert = routeQuery.cert;
                if (routeQuery.cert_no) this.query.cert_no = routeQuery.cert_no;
                if (routeQuery.ct1) this.query.ct1 = routeQuery.ct1;
                if (routeQuery.ct2) this.query.ct2 = routeQuery.ct2;
                if (routeQuery.page) this.pager.page = parseInt(routeQuery.page) || 1;
                if (routeQuery.rows) this.pager.rows = parseInt(routeQuery.rows) || 10;
            } else if (savedParams) {
                // 从 sessionStorage 中读取查询条件
                try {
                    const params = JSON.parse(savedParams);
                    if (params.shape) this.query.shape = params.shape;
                    if (params.col) {
                        this.query.col = params.col;
                        this.checkboxGroup2 = params.col.split(',').filter(v => v);
                    }
                    if (params.cla) {
                        this.query.cla = params.cla;
                        this.checkboxGroup3 = params.cla.split(',').filter(v => v);
                    }
                    if (params.cut) this.query.cut = params.cut;
                    if (params.pol) this.query.pol = params.pol;
                    if (params.sym) this.query.sym = params.sym;
                    if (params.fl) this.query.fl = params.fl;
                    if (params.place) {
                        this.query.place = params.place;
                        this.checkboxGroup12 = params.place.split(',').filter(v => v);
                    }
                    if (params.sale_status) {
                        this.query.sale_status = params.sale_status;
                        this.checkboxGroup13 = params.sale_status.split(',').filter(v => v);
                    }
                    if (params.cert) this.query.cert = params.cert;
                    if (params.cert_no) this.query.cert_no = params.cert_no;
                    if (params.ct1) this.query.ct1 = params.ct1;
                    if (params.ct2) this.query.ct2 = params.ct2;
                    if (params.page) this.pager.page = parseInt(params.page) || 1;
                    if (params.rows) this.pager.rows = parseInt(params.rows) || 10;
                } catch (e) {
                    console.error('Failed to parse saved query params:', e);
                }
            }
            
            // 根据 shape 设置 checkboxGroup1
            if (this.query.shape) {
                const shapeMap = {
                    '圆形': 'Round',
                    '公主方': 'Princess',
                    '雷迪恩': 'Radiant',
                    '阿斯切': 'Asscher',
                    '马眼': 'Marquise',
                    '椭圆形': 'Oval',
                    '祖母绿': 'Emerald',
                    '梨形': 'Pear',
                    '心形': 'Heart',
                    '垫形': 'Cushion',
                    '三角形': 'Triangle',
                    '其他': 'Others'
                };
                const shapes = this.query.shape.split(',').map(s => {
                    for (let key in shapeMap) {
                        if (s.includes(key)) {
                            return shapeMap[key];
                        }
                    }
                    return s;
                });
                this.checkboxGroup1 = shapes.filter(v => v);
            }
            
            this.selectDiamondInfoList();
            //this.selectPlaceDictList();
            this.selectRateDictList();
            /*
            if(sessionStorage.getItem('userType') == 2){
                this.visibleLine = "";
            }*/
            
            // 检测 Safari 浏览器
            this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            

            // 计算表格高度
            this.$nextTick(() => {
                this.calculateTableHeight();
            });
            
            // 监听窗口大小变化
            window.addEventListener('resize', this.calculateTableHeight);
        },
        beforeDestroy() {
            // 移除窗口大小变化监听
            window.removeEventListener('resize', this.calculateTableHeight);
        }
    }
</script>

<style lang="scss" scoped>
    .list-container {
        width: 100%;
        height: 100vh;
        background-color: #fff;
        position: relative;
        overflow: hidden;
    }

    .top-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        background-color: #409EFF;
        padding: 0 15px;
        position: sticky;
        top: 0;
        z-index: 100;

        .header-left,
        .header-right {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #fff;
            font-size: 20px;
            transition: opacity 0.3s;

            &:active {
                opacity: 0.7;
            }
        }

        .header-center {
            flex: 1;
            text-align: center;

            h3 {
                margin: 0;
                color: #fff;
                font-size: 18px;
                font-weight: 500;
            }
        }
    }

    .result-section {
        padding: 0px;
        background-color: #f5f5f5;
        height: calc(100vh - 50px); /* 固定高度，确保可以计算剩余空间 */
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        
        .result-content {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 5px;
            -webkit-overflow-scrolling: touch;
            display: flex;
            flex-direction: column;
            min-height: 0;
            
            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 6px;
            }
            
            &::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
                border-radius: 3px;
                
                &:hover {
                    background-color: #a0a4a8;
                }
            }
            
            &::-webkit-scrollbar-track {
                background-color: #f5f5f5;
                border-radius: 3px;
            }
        }
    }

    .filter-section {
        margin-bottom: 12px;
        background-color: white;
        border-radius: 8px;
        padding: 12px 15px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.08);
    }

    .action-bar {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        margin-bottom: 10px;
        
        .el-button {
            flex: 1;
            min-width: 80px;
            max-width: 120px;
        }
    }

    .statistics-info {
        font-size: 14px;
        color: #333;
        padding-top: 8px;
        border-top: 1px solid #eee;
    }

    .filter-section {
        margin-bottom: 12px;
        background-color: white;
        border-radius: 8px;
        padding: 12px 15px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.08);
        
        &.table-section {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-height: 0;
            overflow: hidden;
            
            .pagination-bar {
                margin-bottom: 12px;
                flex-shrink: 0;
            }
            
            .table-wrapper {
                flex: 1;
                overflow: hidden;
                min-height: 0;
                display: flex;
                flex-direction: column;
                
                .diamond-mobile-table {
                    flex: 1;
                    min-height: 0;
                    display: flex;
                    flex-direction: column;
                    
                    /deep/ .el-table__body-wrapper {
                        flex: 1;
                        overflow-y: auto;
                    }

                    &.safari-only {
                        margin-bottom: 100px;
                    }
                }
            }
        }
    }

    /**手机屏幕展示 */
    @media screen and (max-width: 748px){
        /* 钻石表格专用样式 */
        .diamond-table {
            border: 1px solid #ddd !important;
            table-layout: fixed !important; /* 确保表格布局固定，列宽均等 */
            
            /* 内容列均分样式 */
            .el-table__body-wrapper .el-table__body td:not(.el-table-column--selection):not(.hidden-expand-column) {
                width: 25% !important;
            }
            
            /* 表头均分样式 */
            .el-table__header-wrapper .el-table__header th:not(.el-table-column--selection):not(.hidden-expand-column) {
                width: 25% !important;
            }
            
            /* 隐藏展开箭头列 */
            .hidden-expand-column {
                width: 0 !important;
                padding: 0 !important;
                margin: 0 !important;
                border: none !important;
                overflow: hidden !important;
                
                .cell {
                    display: none !important;
                }
            }
            
            /* 优化选择框列宽度 */
            .el-table-column--selection {
                width: 35px !important;
                min-width: 35px !important;
                padding-right: 0 !important;
                
                .cell {
                    padding-left: 10px !important;
                    padding-right: 0 !important;
                }
            }
            
            /* 隐藏表头中的展开箭头列 */
            .el-table__header-wrapper .el-table__header th.hidden-expand-column {
                padding: 0 !important;
                width: 0 !important;
                min-width: 0 !important;
                border: none !important;
                overflow: hidden !important;
            }
            
            /* 彻底隐藏展开箭头 */
            .el-table__expand-icon {
                display: none !important;
            }
            
            /* 隐藏证书号列前面的展开图标 */
            .el-table__row .el-table__cell:first-child .cell i.el-icon,
            .el-table__row .el-table__cell:nth-child(2) .cell i.el-icon {
                display: none !important;
            }
            
            .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #f2f2f2 !important;
                        border-bottom: 1px solid #ddd !important;
                        padding: 8px 0 !important;
                    }
                }
            }
            
            .el-table__body-wrapper {
                td {
                    padding: 5px 0 !important;
                    font-size: 12px !important;
                }
            }
            
            .el-table__row {
                &:nth-child(even) {
                    background-color: rgba(240, 240, 240, 0.5) !important;
                }
            }
            
            /* 展开行样式 */
            .el-table__expanded-cell {
                padding: 10px !important;
                background-color: #fafafa !important;
                
                .demo-table-expand {
                    font-size: 12px !important;
                    
                    .el-form-item {
                        margin-right: 10px !important;
                        margin-bottom: 0 !important;
                        
                        .el-form-item__label {
                            color: #606266 !important;
                        }
                    }
                }
            }
        }
        
        /* 结果卡片样式 */
        .result-card {
            margin-bottom: 10px;
            
            .el-card__body {
                padding: 10px;
            }
            
            .text {
                margin-bottom: 5px;
                
                span {
                    font-size: 14px !important;
                    line-height: 1.5;
                    display: block;
                    float: none !important;
                    margin-top: 5px;
                }
            }
            
            .el-button {
                margin-right: 5px;
                margin-bottom: 5px;
            }
        }
        
        /* 表格卡片样式 */
        .table-card {
            .el-card__body {
                padding: 10px;
            }
        }
        
        .mainds {
            position: relative;
            float: left;
            height: 500px;
        }
        .mainds {
            font-size: 12px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.71);
            transform: scale(0.71);
            transform-origin: left top;
        }
        /* 表格行颜色样式 */
        .el-table {
            /* 奇数行颜色 */
            .el-table__row--striped td {
                background-color: #eaf3fb !important;
            }
            
            /* 偶数行颜色 */
            .el-table__row:not(.el-table__row--striped) td {
                background-color: #f5f7fa !important;
            }
            
            /* 鼠标悬停效果 */
            .el-table__row:hover td {
                background-color: #e6f1fc !important;
            }
            
            /* 表头固定样式 */
            .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #f0f0f0 !important;
                        color: #333 !important;
                        font-weight: bold !important;
                        border-bottom: 2px solid #ddd !important;
                    }
                }
            }
            
            /* 滚动条样式 */
            .el-table__body-wrapper::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            
            .el-table__body-wrapper::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
                border-radius: 3px;
            }
            
            .el-table__body-wrapper::-webkit-scrollbar-track {
                background-color: #f5f5f5;
            }
            
            /* 单元格边框和内容对齐 */
            td {
                border-color: #ebeef5 !important;
                padding: 4px 0 !important;
            }
            
            /* 表格边框 */
            border: 1px solid #ebeef5 !important;
            border-radius: 4px;
            overflow: hidden;
        }
    }

    /* 移动端查询界面样式 */
    .mobile-header {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #4285f4;
        height: 50px;
        color: white;
        position: relative;
    }

    .header-title {
        font-size: 18px;
        font-weight: bold;
    }

    .back-button {
        position: absolute;
        left: 10px;
        padding: 5px;
        background: transparent;
        border: none;
        color: white;
    }

    .search-section {
        padding: 0px;
        background-color: #f5f5f5;
        /* height: auto; 改为自适应高度 */
        height: 450px;
        position: relative;
        display: flex;
        flex-direction: column;
        
        .search-content {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding-bottom: 10px; /* 为底部按钮留出空间 */
            
            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            
            &::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
                border-radius: 3px;
            }
            
            &::-webkit-scrollbar-track {
                background-color: #f5f5f5;
            }
        }
        
        .action-buttons {
            position: relative; /* 改为相对定位 */
            background: white;
            padding: 10px;
            border-top: 1px solid #eee;
            box-shadow: 0 -2px 4px rgba(0,0,0,0.05);
            margin-top: 10px; /* 添加顶部间距 */
        }
    }

    .filter-section {
        margin-bottom: 0;
        background-color: white;
        border-radius: 5px;
        padding: 8px;
    }

    .filter-title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #333;
        border-bottom: 1px solid #eee;
        padding-bottom: 5px;
    }

    .filter-content {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
    }

    /* 形状选择样式 */
    .shape-content {
        justify-content: space-between;
    }

    .shape-item {
        width: 50px;
        height: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        margin-bottom: 5px;
        padding: 2px 1px 0;
    }

    .shape-item.active {
        background-color: #e6f1fc;
        border-color: #4285f4;
    }

    .shape-icon {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .shape-name {
        font-size: 12px;
        text-align: center;
        margin-top: auto;
        margin-bottom: 0;
    }

    .el-icon-round, .el-icon-princess, .el-icon-radiant,
    .el-icon-asscher, .el-icon-marquise, .el-icon-oval,
    .el-icon-emerald, .el-icon-pear1, .el-icon-heart,
    .el-icon-cushion, .el-icon-others, .el-icon-triangle {
        background-size: 30px 30px;
        width: 30px;
        height: 30px;
        margin: 0;
    }

    /* 克拉选择样式 */
    .carat-range {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        margin-bottom: 10px;
        width: 100%;
    }

    .carat-item {
        padding: 5px 8px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        text-align: center;
        flex: 1;
        min-width: 40px;
    }

    .carat-item.active {
        background-color: #e6f1fc;
        border-color: #4285f4;
        color: #4285f4;
    }

    .carat-custom {
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
    }

    .carat-input {
        max-width: 80px;
    }

    .separator {
        margin: 0 5px;
    }

    /* 颜色、净度、切工等共用样式 */
    .color-item, .clarity-item, .cut-item, .polish-item, .symmetry-item, .fluorescence-item, .cert-item, .location-item, .other-item, .quick-item {
        padding: 5px 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        text-align: center;
        margin-right: 5px;
        margin-bottom: 5px;
    }

    .color-item.active, .clarity-item.active, .cut-item.active, .polish-item.active, .symmetry-item.active, .fluorescence-item.active, .cert-item.active, .location-item.active, .other-item.active, .quick-item.active {
        background-color: #e6f1fc;
        border-color: #4285f4;
        color: #4285f4;
    }

    /* 表单输入组样式 */
    .input-group {
        margin-bottom: 0;
    }

    .input-label {
        margin-bottom: 5px;
        font-size: 14px;
    }

    /* 加点控制样式 */
    .point-control {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .point-value {
        width: 40px;
        text-align: center;
        font-size: 16px;
    }

    /* 操作按钮样式 */
    .action-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .search-btn, .reset-btn {
        flex: 1;
        height: 40px;
        margin: 0 5px;
    }

    .search-btn {
        background-color: #4285f4;
    }

    /* 复选框组样式 */
    .checkbox-group {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-top: 10px;
    }


    .el-dialog{
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
    .el-icon-round {
        background:url('../../assets/images/cut2/round.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-princess {
        background:url('../../assets/images/cut2/princess.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-radiant {
        background:url('../../assets/images/cut2/radiant.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-asscher {
        background:url('../../assets/images/cut2/asscher.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-marquise {
        background:url('../../assets/images/cut2/marquise.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-oval {
        background:url('../../assets/images/cut2/oval.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-emerald {
        background:url('../../assets/images/cut2/emerald.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-pear1 {
        background:url('../../assets/images/cut2/pear1.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-heart {
        background:url('../../assets/images/cut2/heart.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-cushion {
        background:url('../../assets/images/cut2/cushion.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-others {
        background:url('../../assets/images/cut2/others.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-triangle {
        background:url('../../assets/images/cut2/triangle.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    /* 修改分页组件样式 */
    @media screen and (max-width: 748px) {
        .block.tar.mar_t {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 10px 0;

            .el-pagination {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 5px;
                padding: 5px;
                white-space: normal;
                width: 100%;
                
                /* 总数和每页条数 */
                .el-pagination__total,
                .el-pagination__sizes {
                    height: 28px;
                    margin: 0 15px;
                }
                
                /* 页码按钮组 */
                .el-pager {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    margin: 0;
                    
                    li {
                        min-width: 28px;
                        height: 28px;
                        line-height: 28px;
                        margin: 0 2px;
                        
                        &.active {
                            background-color: #409EFF;
                            color: #fff;
                        }
                    }
                }
                
                /* 上一页下一页按钮 */
                .btn-prev,
                .btn-next {
                    min-width: 28px;
                    height: 28px;
                    line-height: 28px;
                    padding: 0;
                    margin: 0 2px;
                }
                
                /* 跳转页输入框 */
                .el-pagination__jump {
                    margin: 0 5px;
                    height: 28px;
                    line-height: 28px;
                    
                    .el-input {
                        width: 50px;
                        margin: 0 5px;
                        
                        input {
                            height: 28px;
                            line-height: 28px;
                            text-align: center;
                        }
                    }
                }

                /* 特小屏幕适配 */
                @media screen and (max-width: 375px) {
                    .el-pagination__sizes {
                        display: none; // 隐藏每页条数选择器
                    }
                    
                    .el-pagination__jump {
                        margin: 5px 0;
                    }
                }
            }
        }
    }

    .diamond-mobile-table {
        width: 100%;
        margin: 0;
        padding: 0;
        
        /* 隐藏展开箭头 */
        .el-table__expand-icon {
            display: none;
        }
        
        /* 内容紧凑化 */
        .el-table__cell {
            padding: 2px 0 !important;
        }
        
        /* 表头样式优化 */
        .el-table__header-wrapper th {
            background-color: #f8f8f8 !important;
            padding: 5px 0 !important;
        }
        
        /* 选中行样式 */
        .el-table__row.current-row {
            background-color: #f0f7ff !important;
        }
        
        /* 奇偶行样式 */
        .el-table__row:nth-child(odd) {
            background-color: #fff;
        }
        
        .el-table__row:nth-child(even) {
            background-color: #fafafa;
        }
        
        /* 点击时的高亮效果 */
        .el-table__row:active {
            background-color: #e6f1fc;
        }
        
        /* 价格区域样式 */
        .price-area {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .media-links {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 3px;
    }
    
    .image-link, .vedio_link {
        cursor: pointer;
        
        i {
            color: #409EFF;
            font-size: 14px;
            &:hover {
                color: #66b1ff;
            }
        }
    }
    
    .vedio_link .el-icon-video-camera {
        color: #F56C6C;
        &:hover {
            color: #f78989;
        }
    }

    .image-dialog-content {
        display: flex;
        justify-content: center;
        align-items: center;
        
        .diamond-image {
            max-width: 100%;
            max-height: 70vh; // 限制高度为视口高度的70%
            object-fit: contain;
        }
    }
    
    .video-dialog-content {
        display: flex;
        justify-content: center;
        align-items: center;
        
        .diamond-video {
            max-width: 100%;
            max-height: 70vh; // 限制高度为视口高度的70%
            object-fit: contain;
        }
    }

    // 调整对话框样式
    .el-dialog__header {
        padding: 15px 20px 10px;
        text-align: center;
        border-bottom: 1px solid #ebeef5;
    }

    .el-dialog__body {
        padding: 15px;
    }

    // 适配移动端样式
    @media screen and (max-width: 748px) {
        .el-dialog {
            width: 95% !important;
            margin-top: 20vh !important;
        }
        
        /* 移动端输入框字体大小修复，防止iOS Safari自动放大 */
        .el-input {
            /deep/ .el-input__inner {
                font-size: 16px;
            }
        }
        
        /* 对话框中的输入框 */
        .el-dialog {
            .el-input {
                /deep/ .el-input__inner {
                    font-size: 16px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/phone/diamondShopListMobile.vue